import React, { useState, useEffect } from "react";
import { Modal, Button, Table, IconButton } from "@deere/ux.uxframe-react";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";
import { saveContactData, deleteCampaignContacts, getSupplierContacts, saveNonDeereContactData, deleteCampaignNonDeereContacts } from "../../services/campaign.service";
import { getDeereContacts } from "../../services/external.service";
import { useUserInfo } from "../../providers/userProvider";
import { useOktaAuth } from "@okta/okta-react";
import { ERR_EXISTING_CONTACT, ERR_SELECT_OPTION } from "../../utils/errorLiterals";
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import debounce from 'debounce-async';

const ModalContactUpdate = ({ showModal, setShowModal, labelBtnPrimary, labelBtnSecondary, handleSubmit, dataModal, titleModal, onClose, loadCampaing, campaign }) => {
  const { authState } = useOktaAuth();
  const userInfo = useUserInfo();
  const [newContacts, setNewContacts] = useState([]);
  const [existingContacts, setExistingContacts] = useState([]);
  const [newInput, setNewInput] = useState(null);
  const [optAutocomplete, setOptAutocomplete] = useState([]);
  const [error, setError] = useState("");
  let isDeereContact = false;
  let isCompanyContact= false;
  if (dataModal) {
    if (dataModal.toUpdate === "deereContactName") isDeereContact = true;
    if(campaign.isNonDeere && (dataModal.toUpdate === "companyContactName")) isCompanyContact = true;
  }

  useEffect(() => {
    let arrData = [];
    if (dataModal) {
      if(!campaign.isNonDeere){
        if (isDeereContact) {
          arrData = dataModal.data.filter((item) => item.deereContact);
          arrData.forEach((data) => {
            data.fullName = dataModal.rowData.deereContactName.find((item) => item.includes(data.userId));
          });
        } else {
          arrData = dataModal.data.filter((item) => !item.deereContact);
          arrData.forEach((data) => {
            data.fullName = dataModal.rowData.supplierContactName.find((item) => item.includes(data.userId));
          });
        }
      }else{
        if (isCompanyContact) {
          arrData = dataModal.data.filter((item) => item.companyContact);
          arrData.forEach((data) => {
            data.fullName = dataModal.rowData.companyContactName.find((item) => item.includes(data.userId));
          });
        } else {
          arrData = dataModal.data.filter((item) => !item.companyContact);
          arrData.forEach((data) => {
            data.fullName = dataModal.rowData.nonDeereSupplierContactsIds.find((item) => item.includes(data.userId));
          });
        }
      }

      setExistingContacts([...arrData]);

      if (!isDeereContact) {
        getSupplierContacts(dataModal.rowData.supplierNumber, authState.accessToken.accessToken).then((res) => {
          let tempContacts = [];
          if (res && res !== null) {
            res.forEach((contact) => {
              let lastName = contact && contact.lastName ? contact.lastName : "";
              let firstName = contact && contact.firstName ? contact.firstName : "";
              let contactUserId = contact && contact.contactUserId ? contact.contactUserId : "";
              tempContacts.push({ label: lastName + ", " + firstName + " - " + contactUserId, value: contactUserId });
            });
          }
          setOptAutocomplete(tempContacts);
          setLastOptions(tempContacts);
        });
      }
    }
  }, [dataModal]);

  const changeHandler = (event) => {
     if(campaign.isNonDeere){
      setNewInput(event.target.value);
     }else{
      setNewInput(event);
     }
      setError("");
  };

  const addHandler = () => {
    if (newInput && newInput !== null) {
      let newDuplicate = newContacts.find((item) =>(item.value === newInput.value)); 
      let newDuplicateNonDeere= newContacts.find((item) =>(item === newInput))
      let existingDuplicate = existingContacts.find((item) => (item.userId === newInput.value && !item.deletedByUser));
      let existingDuplicateNonDeere = existingContacts.find((item) =>item.emailId === newInput && !item.deletedByUser);
      if(!campaign.isNonDeere){
        if (newDuplicate || existingDuplicate) setError(ERR_EXISTING_CONTACT);
        else {
          setNewContacts((prevState) => [...prevState, newInput]);
          setNewInput("");
          setError("");
        }
      }else{
        if (newDuplicateNonDeere || existingDuplicateNonDeere) setError(ERR_EXISTING_CONTACT);
        else {
          setNewContacts((prevState) => [...prevState, newInput]);
          setNewInput("");
          setError("");
        }
      }
    } else setError(ERR_SELECT_OPTION);
  };

  const deleteHandler = (contact, id, isExisting) => {
    if (isExisting) {
      setExistingContacts((prevState) => {
        prevState.forEach((data) => {
          if (data.id === id) data.deletedByUser = true;
        });
        return [...prevState];
      });
    } else {
      setNewContacts((prevState) => {
        let newState = prevState.filter((data) => {
          return campaign.isNonDeere? data !==contact : data.value !== id;
        });
        return [...newState];
      });
    }
  };

  const saveContactsHandler = () => {
    const arrToSave = [];
    const arrToDelete = [];
    const objToSave = {
      campaignAssignmentId: dataModal.assignmentId,
      deereContact: isDeereContact,
      createdBy: userInfo.userID,
      updatedBy: userInfo.userID,
    };
    const nonDeereObjToSave = {
      assignmentId: dataModal.assignmentId,
      isCompanyContact: isCompanyContact,
      createdBy: userInfo.userID,
      createdBy: userInfo.userID,
      contactEmail:""
    };
    newContacts.forEach((item) => {
      if(!campaign.isNonDeere){
        arrToSave.push({ userId: item.value, ...objToSave });
      }else{
        arrToSave.push({  ...nonDeereObjToSave, emailId: item, contactEmail: item });
      }

    });
    existingContacts.forEach((item) => {
      if (item.deletedByUser) arrToDelete.push({ assignmentId: dataModal.assignmentId, id: item.id });
    });

    if (arrToSave.length > 0) {
      if(!campaign.isNonDeere){
        saveContactData(arrToSave, authState.accessToken.accessToken).then((res) => {
          if (arrToDelete.length > 0) {
            let resCount = 0;
            arrToDelete.forEach((item) => {
              deleteCampaignContacts(item, authState.accessToken.accessToken)
                .then(() => {
                  resCount++;
                  if (resCount === arrToDelete.length) resetAllStates();
                })
                .catch(() => {
                  resCount++;
                });
            });
          } else resetAllStates();
        });
      }else{
        saveNonDeereContactData(arrToSave, authState.accessToken.accessToken).then((res) => {
          if (arrToDelete.length > 0) {
            let resCount = 0;
            arrToDelete.forEach((item) => {
              deleteCampaignNonDeereContacts(item, authState.accessToken.accessToken)
                .then(() => {
                  resCount++;
                  if (resCount === arrToDelete.length) resetAllStates();
                })
                .catch(() => {
                  resCount++;
                });
            });
          } else resetAllStates();
        });
      }
    } else if (arrToDelete.length > 0) {
      let resCount = 0;
      if (!campaign.isNonDeere) {
        arrToDelete.forEach((item) => {
          deleteCampaignContacts(item, authState.accessToken.accessToken)
            .then(() => {
              resCount++;
              if (resCount === arrToDelete.length) resetAllStates();
            })
            .catch(() => {
              resCount++;
            });
        });
      } else {
        arrToDelete.forEach((item) => {
          deleteCampaignNonDeereContacts(item, authState.accessToken.accessToken)
            .then(() => {
              resCount++;
              if (resCount === arrToDelete.length) resetAllStates();
            })
            .catch(() => {
              resCount++;
            });
        });
      }
    } else resetAllStates();
  };

  const resetAllStates = () => {
    setShowModal(false);
    setNewContacts([]);
    setExistingContacts([]);
    setNewInput("");
    setError("");
    setOptAutocomplete([]);
    loadCampaing();
    setLastOptions([]);
    setShowOptions([]);
  };

  const closeModal = () => {
    setNewContacts([]);
    setExistingContacts([]);
    setNewInput("");
    setError("");
    setOptAutocomplete([]);
    setLastOptions([]);
    setShowOptions([]);
    if (onClose) onClose();
    else setShowModal(false);
  };

  const isOptionSelected = (option, values) => {
    return values.some(({ value }) => option.value === value);
  };

  const [lastOptions, setLastOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);

  const loadOptions = React.useMemo(() => {
    return debounce(async (inputValue) => {
      let options = undefined;
      const suppliers = await getDeereContacts(inputValue, authState.accessToken.accessToken);
      options = suppliers.map((item) => ({ label: item.userLastname + ", " + item.userFirstname + " - " + item.userid, value: item.userid }))
      setLastOptions(options)
      return options

    }, 300);
  }, [authState.accessToken.accessToken])

  const handleInputChange = React.useCallback((typedOption) => {
    (typedOption.length > 1) ? setShowOptions(true) : setShowOptions(false);
  }, []);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'black' : 'black'
    }),
    control: base => ({
      ...base,
      height: 35,
      minHeight: 35,
      width: 'auto'
    }),
    menu: base => ({
      ...base,
      position: 'relative'
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 35,
      minHeight: 35,
    }),
    placeholder: base => ({
      ...base,
    }),
    valueContainer: base => ({
      ...base,
      height: 35,
      minHeight: 35,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;

      return { ...provided, opacity };
    }
  }

  return (
    <Modal show={showModal} onHide={handleSubmit} backdrop="static">
      <Modal.Header>
        <Modal.Title>{titleModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-scroll">
        <Table>
          <tbody>
            {existingContacts.map((data) => {
              if (!data.deletedByUser) {
                return (
                  <tr key={data.id}>
                    <td>{data.fullName ? data.fullName : data.emailId}</td>
                    <td>
                      <IconButton ariaLabel="Delete" onClick={() => deleteHandler(data, data.id, true)}>
                        <DeleteIcon />
                      </IconButton>
                    </td>
                  </tr>
                );
              }
            })}
            {newContacts.map((data) => {
              return (
                <tr key={data.value}>
                  <td>{campaign.isNonDeere?data:data.label}</td>
                  <td>
                    <IconButton ariaLabel="Delete" onClick={() => deleteHandler(data, data.value, false)}>
                      <DeleteIcon />
                    </IconButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {!campaign.isNonDeere? (
          <div style={{ display: "flex", justifyContent: 'space-around' }}>
            {isDeereContact ? (
              <div style={{ width: '80%' }}>
                  <AsyncSelect
                    cacheOptions={true}
                    defaultOptions
                    loadOptions={showOptions ? loadOptions : null}
                    isOptionSelected={isOptionSelected}
                    value={newInput}
                    onInputChange={handleInputChange}
                    isClearable={true}
                    styles={customStyles}
                    noOptionsMessage={() => 'Start Typing...'}
                    onChange={changeHandler}
                  />
              </div>
              ) : (
                <div style={{ width: '80%' }}>
                  <Select
                    cacheOptions={true}
                    defaultOptions
                    options={optAutocomplete}
                    isOptionSelected={isOptionSelected}
                    value={newInput}
                    isClearable={true}
                    styles={customStyles}
                    noOptionsMessage={() => 'Start Typing...'}
                    onChange={changeHandler}
                  />
                </div>
              )}
              <div className="max-h-10">
                  <Button variant="secondary" onClick={addHandler} disabled={lastOptions.length === 0}>
                    Add
                  </Button>
              </div>
          </div>
          ):(
            <div style={{ display: "flex", justifyContent: 'space-around' }}>
              <input onChange={changeHandler} value={newInput} placeholder="Enter contact email"></input>
              <div className="max-h-10">
                <Button variant="secondary" onClick={addHandler} >
                  Add
                </Button>
              </div>
            </div>
             )}

        {error !== "" && <div style={{ color: "red", fontSize: "smaller" }}>{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          {labelBtnSecondary}
        </Button>
        <Button type="submit" variant="primary" onClick={saveContactsHandler}>
          {labelBtnPrimary}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalContactUpdate;
